import { AxiosInstance } from 'axios';
import { AudienceInsight, EventType, SummaryStats, TopOffer, TrendData } from 'referral-types';
import { simulate } from './utils';

export const baseEndpoint = 'analytics';

export type TrackEventParams = {
  groupReferralId: string;
  visitorId: string;
  eventType: EventType;
  referrer?: string;
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
};

export type AnalyticsQueryParams = {
  startDate?: string;
  endDate?: string;
  groupReferralId?: string;
};

export type AudienceQueryParams = AnalyticsQueryParams & {
  breakdown?: 'device' | 'country' | 'referrer' | 'utm_source' | 'utm_medium' | 'utm_campaign';
};

export class AnalyticsApi {
  private apiInstance: AxiosInstance;

  constructor(apiInstance: AxiosInstance) {
    this.apiInstance = apiInstance;
  }

  async track(params: TrackEventParams): Promise<{ success: boolean }> {
    // No simulate for tracking - this should be fast
    const response = await this.apiInstance.post('/track', params);

    return response.data;
  }

  async getStats(params?: AnalyticsQueryParams): Promise<SummaryStats> {
    await simulate();
    const response = await this.apiInstance.get('/stats', { params });

    return response.data;
  }

  async getTrends(params?: AnalyticsQueryParams): Promise<Array<TrendData>> {
    await simulate();
    const response = await this.apiInstance.get('/trends', { params });

    return response.data;
  }

  async getTopOffers(params?: Omit<AnalyticsQueryParams, 'groupReferralId'>): Promise<Array<TopOffer>> {
    await simulate();
    const response = await this.apiInstance.get('/top-offers', { params });

    return response.data;
  }

  async getAudience(params?: AudienceQueryParams): Promise<Array<AudienceInsight>> {
    await simulate();
    const response = await this.apiInstance.get('/audience', { params });

    return response.data;
  }
}
